import { useEffect } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router";

import {
  loginActions,
  emailVerificationActions,
} from "../../redux/actions";
import { authenticatedRouting } from "../../system";
import { useSpinner } from "../../shared/components/hooks/useSpinner/useSpinner";
import { loginConstants, paramsConstants } from "../../constants";

const {
  TOKEN,
  FROM_FR,
  BRAND_ID,
  LOCATION_ID,
  VERIFICATION_TOKEN,
  ENCRYPTED_PARAMETERS,
  CUSTOMER_CONVERSATION_ID,
} = paramsConstants;

// Send users to the right screen for their sign-in state and the link they opened.
const AuthenticationRouter = (props) => {
  const {
    confirmEmail,
    isAuthenticated,
    handleAdminToken,
    allBrandsWithFeatureFlags,
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  //Collecting the data in params when redirecting from FR
  const params = new URLSearchParams(location.search);
  const [encryptedParams] = useSearchParams();

  const token = params.get(TOKEN);
  const fromFR = params.get(FROM_FR);
  const brandId = params.get(BRAND_ID);
  const locationId = params.get(LOCATION_ID);
  const encryptedBody = encryptedParams.get(ENCRYPTED_PARAMETERS);
  const verificationToken = encryptedParams.get(VERIFICATION_TOKEN);
  const customerConversationId = params.get(CUSTOMER_CONVERSATION_ID);

  // Wait until feature flags are loaded before choosing a screen.
  const spinner = useSpinner();
  const featureFlagSpinner = spinner(
    loginConstants.GET_ALL_BRANDS_WITH_FEATURE_FLAGS
  );

  useEffect(() => {
    if (!featureFlagSpinner) {
      let ids = { locationId, brandId, customerConversationId };
      let encryptedParamsObj = { verificationToken, encryptedBody };

      authenticatedRouting({
        ids,
        token,
        fromFR,
        navigate,
        confirmEmail,
        isAuthenticated,
        handleAdminToken,
        encryptedParamsObj,
        pathname: location.pathname,
        allBrandsWithFeatureFlags,
      });
    }
    // Re-run on pathname so direct URL navigation to admin tools is guarded.
    // eslint-disable-next-line
  }, [isAuthenticated, featureFlagSpinner, location.pathname]);

  return null;
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.authentication.isAuthenticated,
  allBrandsWithFeatureFlags: state.system.allBrandsWithFeatureFlags,
});

const mapDispatchToProps = (dispatch) => ({
  handleAdminToken: (token) => dispatch(loginActions.handleAdminToken(token)),
  confirmEmail: (token, navigate) =>
    dispatch(emailVerificationActions.confirmEmail(token, navigate)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthenticationRouter);
